import BatchOperations from './BatchOperations';

export default BatchOperations;
